import React, { useState } from "react";
import { format, parseISO } from "date-fns";
import { JourneyEvent } from "../../../api/analyticsAdmin";
import { buildHumanizedRows } from "../../../helpers/eventHumanizer";
import { EventProperties } from "./EventProperties";

export const GroupedTimeline: React.FC<{
  events: JourneyEvent[];
  businessNames: Map<string, string>;
}> = ({ events, businessNames }) => {
  const rows = buildHumanizedRows(events, businessNames);
  const [expandedKey, setExpandedKey] = useState<string | null>(null);

  if (rows.length === 0) {
    return (
      <div className="text-sm text-gray-400">No notable events in this session.</div>
    );
  }

  return (
    <ol className="flex flex-col">
      {rows.map((row) => {
        const isOpen = expandedKey === row.key;
        return (
          <li key={row.key} className="relative pl-6 pb-4 border-l-2 border-gray-100">
            <span
              className="absolute -left-[7px] top-1.5 w-3 h-3 rounded-full ring-2 ring-white"
              style={{ backgroundColor: row.color }}
            />
            <button
              onClick={() => setExpandedKey(isOpen ? null : row.key)}
              className="w-full text-left"
            >
              <div className="flex items-baseline justify-between gap-3">
                <span className="font-medium text-gray-800">
                  {row.text}
                  {row.count > 1 && (
                    <span className="ml-2 text-xs px-1.5 py-0.5 rounded-full bg-gray-100 text-gray-500">
                      ×{row.count}
                    </span>
                  )}
                </span>
                <span className="text-xs text-gray-400 whitespace-nowrap">
                  {format(parseISO(row.firstTimestamp), "HH:mm:ss")}
                </span>
              </div>
            </button>

            {isOpen && (
              <div className="mt-2 bg-gray-50 rounded-lg p-3">
                {row.count > 1 ? (
                  <div className="flex flex-col gap-3">
                    {row.events.map((event) => (
                      <div key={event.uuid}>
                        <div className="text-xs text-gray-400 mb-1">
                          {event.event} · {format(parseISO(event.timestamp), "HH:mm:ss")}
                        </div>
                        <EventProperties propertiesJson={event.propertiesJson} />
                      </div>
                    ))}
                  </div>
                ) : (
                  <div>
                    <div className="text-xs text-gray-400 mb-1">{row.events[0].event}</div>
                    <EventProperties propertiesJson={row.events[0].propertiesJson} />
                  </div>
                )}
              </div>
            )}
          </li>
        );
      })}
    </ol>
  );
};
